import { DestroyRef, Directive, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TimeFrameSelectionComponent } from '@components/time-frame-selection/time-frame-selection.component';
import { filter } from 'rxjs';
import { ElementContext } from '../../element-handling/element-context';
import { ChartBindingDirective } from './chart-controller.directive';
import { ChartTimeframeControllerDirective } from './chart-timeframe-controller.directive';
import { SelectedTimeframe } from './selected-timeframe';

@Directive({
  selector: '[timeframePreselection]',
  standalone: true,
})
export class TimeframePreselectionDirective implements OnInit {
  @Input({ required: true }) public timeframeSelector: TimeFrameSelectionComponent;

  private readonly timeframeController = inject(ChartTimeframeControllerDirective);
  private readonly chartBinding = inject(ChartBindingDirective);
  private readonly destroyRef = inject(DestroyRef);
  private readonly elementContext = inject(ElementContext);

  ngOnInit() {
    this.chartBinding.binding.chart$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.elementContext
        .getElement('DefaultTimeframe')
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          filter(element => !!element)
        )
        .subscribe(defaultTimeframeElement => {
          const defaultTimeframe: SelectedTimeframe = defaultTimeframeElement.renderable.content as SelectedTimeframe;

          const timeframe: SelectedTimeframe = Object.keys(SelectedTimeframe).includes(defaultTimeframe) ? defaultTimeframe : SelectedTimeframe.YTD;
          this.timeframeController.controller.updateSelection(timeframe, false);
          this.timeframeSelector.setSelection(timeframe);
        });
    });
  }
}
